// GA4のgaイベント送信はタグマネージャー上で行うため基本的に実装は不要ですが、
// ・タグマネージャーのみでは設定できない任意の条件でイベントを設定したい
// ・何らかの事情（タグマネージャー上で要素を認識できないなど）により、React側でクリックなどのイベントを設定したい
// などの場合には、このモジュールを使用して、以下のような形でデータを手動で渡す必要があります。
//
// pushDataLayer({
//   event: "modal_open",
//   job_id: gaLabel,
// });

declare const dataLayer: Record<string, string>[];

export const pushDataLayer = (data: Record<string, string>) => {
  if (typeof dataLayer !== "undefined") {
    dataLayer.push(data);
  }
};
